const USER_LOCALSTORAGE_KEY = "currentUser";

export { USER_LOCALSTORAGE_KEY };
